module.exports = __webpack_public_path__ + "static/media/total_employee.618a1879.svg";